<template>
  <div class="countdown">
    <span>00 : 0{{ minutes }} : {{ second }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minutes: 4, //分
      seconds: 59, //秒
    };
  },
  methods: {
    // 倒计时
    num(n) {
      // 倒计时结束重新刷新页面
      if (this.minutes === 0 && this.seconds === 2) {
        // this.$message.warning('支付倒计时结束!即将刷新页面!');
      }
      if (this.minutes === 0 && this.seconds === 0) {
        // window.location.reload();
      }
      return n < 10 ? "0" + n : "" + n;
    },
    // 倒计时
    timer() {
      var _this = this;
      var time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
           let timeOut =  _this.seconds
          _this.$emit('showTime',timeOut);
          window.clearInterval(time);
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
  },
  mounted() {
    // 倒计时
    this.timer();
  },
  watch: {
    // 倒计时
    second: {
      handler(newVal) {
        this.num(newVal);
      },
    },
    // 倒计时
    minute: {
      handler(newVal) {
        this.num(newVal);
      },
    },
  },
  computed: {
    // 倒计时
    second: function () {
      return this.num(this.seconds);
    },
    minute: function () {
      return this.num(this.minutes);
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown {
  position: absolute;
  z-index: 44;
  right: 210px;
  top: 100px;
  /* left: 50%; */
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  /* top: 10px; */
  padding: 3px 0;
  /* width: 107px; */
  height: 18px;
  font-weight: 600;
  color: #fbddcc;

  font-size: 37px;
  line-height: 20px;
  i {
    padding: 0 5px 0 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/common/components/ByCountDowm.vue